{
    "title": "Demander à Plato",
    "trigger": "Demander à Plato",
    "close": "Fermer Demander à Plato",
    "send": "Envoyer",
    "scroll_to_bottom": "Aller en bas",
    "thinking": "Réflexion en cours…",
    "placeholder": "Posez une question sur les clients, le CA, les tâches…",
    "error": "Une erreur est survenue. Veuillez réessayer.",
    "like": "Évaluer la réponse positivement",
    "dislike": "Évaluer la réponse négativement",
    "copy": "Copier",
    "copied": "Copié",
    "disclaimer": "Demander à Plato est expérimental et peut faire des erreurs. Merci de vérifier les informations importantes avant de les utiliser.",
    "ask_support": "Contacter le support",
    "retry": "Réessayer",
    "support_message": "Demander à Plato n'a pas pu répondre à cette question :\n\n{{question}}\n\n",
    "error_explanation": "Je rencontre actuellement un problème technique. Réessayez plus tard ou contactez directement notre support.",
    "welcome": "Bonjour ! Je connais vos clients, vos commandes et vos activités. Que souhaitez-vous savoir ?",
    "teaser": "Des questions ? Plato vous aide !",
    "teaser_dismiss": "Masquer l'indication",
    "home_card__subtitle": "Je connais vos clients, vos commandes et vos activités. Que souhaitez-vous savoir ?",
    "home_card__greeting_morning": "Bonjour, {{name}}",
    "home_card__greeting_day": "Bonjour, {{name}}",
    "home_card__greeting_evening": "Bonsoir, {{name}}",
    "home_card__starter_visit_prep_label": "Préparer un rendez-vous client",
    "home_card__starter_visit_prep": "Prépare mon rendez-vous chez {{caret}}",
    "home_card__starter_revenue_decline": "Lesquels de mes clients perdent du CA, et pourquoi ?",
    "home_card__starter_revenue_vs_last_year": "Comment évolue mon CA cette année par rapport à l'an dernier ?",
    "home_card__starter_revenue_decline_label": "Clients en baisse de CA",
    "home_card__starter_revenue_vs_last_year_label": "Mon CA vs. l'an dernier",
    "new_chat": "Nouvelle conversation",
    "context_limit_reached": "Limite de la conversation atteinte.",
    "context_limit_reached_explanation": "Cette conversation a atteint sa longueur maximale. Démarrez une nouvelle conversation pour continuer.",
    "start_new_chat": "Démarrer une nouvelle conversation",
    "history": "Historique",
    "history_empty": "Aucune conversation pour l'instant.",
    "back": "Retour à la conversation",
    "history_today": "Aujourd'hui",
    "history_yesterday": "Hier",
    "history_last_7_days": "7 derniers jours",
    "history_older": "Plus ancien",
    "tool__generic__running": "Traitement en cours",
    "tool__generic__done": "Données consultées",
    "tool__failed": "Impossible de récupérer ces données",
    "tool__interrupted": "Interrompu avant la fin",
    "tool__find_plato_page__running": "Recherche de la page correspondante dans Plato",
    "tool__find_plato_page__done": "Page correspondante recherchée dans Plato",
    "tool__get_customer_notes__running": "Lecture des notes",
    "tool__get_customer_notes__done": "Notes lues",
    "tool__get_customer_notes__done_search": "Notes correspondant à « {{search}} » lues",
    "tool__get_pinned_customer_notes__running": "Lecture des notes épinglées",
    "tool__get_pinned_customer_notes__done": "Notes épinglées lues",
    "tool__get_note__running": "Lecture d'une note",
    "tool__get_note__done": "Note lue",
    "tool__get_data_freshness__running": "Vérification de l'actualité des données",
    "tool__get_data_freshness__done": "Actualité des données vérifiée",
    "tool__get_daily_order_intake__running": "Vérification des commandes reçues aujourd'hui et hier",
    "tool__get_daily_order_intake__done": "Commandes reçues aujourd'hui et hier vérifiées",
    "tool__get_sales_summary__running": "Lecture du résumé des ventes de l'année en cours",
    "tool__get_sales_summary__done": "Résumé des ventes de l'année en cours lu",
    "tool__get_sales_totals__running": "Calcul des totaux de ventes",
    "tool__get_sales_totals__done": "Totaux de ventes calculés",
    "tool__get_monthly_trend__running": "Chargement de l'évolution mensuelle du CA",
    "tool__get_monthly_trend__done": "Évolution mensuelle du CA chargée",
    "tool__get_revenue_by_year__running": "Comparaison du CA sur plusieurs années",
    "tool__get_revenue_by_year__done": "CA comparé sur plusieurs années",
    "tool__get_top_customers__running": "Classement des clients",
    "tool__get_top_customers__done": "Clients classés",
    "tool__get_top_customers__done_search": "Clients correspondant à « {{search}} » classés",
    "tool__get_top_products__running": "Classement des articles",
    "tool__get_top_products__done": "Articles classés",
    "tool__get_top_products__done_search": "Articles correspondant à « {{search}} » classés",
    "tool__get_top_product_groups__running": "Classement des groupes d'articles",
    "tool__get_top_product_groups__done": "Groupes d'articles classés",
    "tool__get_top_product_groups__done_search": "Groupes d'articles correspondant à « {{search}} » classés",
    "tool__get_top_categories__running": "Classement des groupes de marchandises",
    "tool__get_top_categories__done": "Groupes de marchandises classés",
    "tool__get_top_categories__done_search": "Groupes de marchandises correspondant à « {{search}} » classés",
    "tool__get_top_suppliers__running": "Classement des fournisseurs",
    "tool__get_top_suppliers__done": "Fournisseurs classés",
    "tool__get_top_suppliers__done_search": "Fournisseurs correspondant à « {{search}} » classés",
    "tool__get_top_clerks__running": "Classement des saisisseurs",
    "tool__get_top_clerks__done": "Saisisseurs classés",
    "tool__get_top_clerks__done_search": "Saisisseurs correspondant à « {{search}} » classés",
    "tool__get_top_sales_reps__running": "Classement des commerciaux",
    "tool__get_top_sales_reps__done": "Commerciaux classés",
    "tool__get_top_sales_reps__done_search": "Commerciaux correspondant à « {{search}} » classés",
    "tool__get_top_storage_locations__running": "Classement des entrepôts",
    "tool__get_top_storage_locations__done": "Entrepôts classés",
    "tool__get_top_storage_locations__done_search": "Entrepôts correspondant à « {{search}} » classés",
    "tool__get_top_industries__running": "Classement des secteurs",
    "tool__get_top_industries__done": "Secteurs classés",
    "tool__get_top_industries__done_search": "Secteurs correspondant à « {{search}} » classés",
    "tool__get_customer_details__running": "Lecture des détails du client",
    "tool__get_customer_details__done": "Détails du client lus",
    "tool__get_customer_financials__running": "Lecture des indicateurs financiers du client",
    "tool__get_customer_financials__done": "Indicateurs financiers du client lus",
    "tool__get_customer_segment_aggregates__running": "Agrégation d'un segment de clients",
    "tool__get_customer_segment_aggregates__done": "Segment de clients agrégé",
    "tool__get_quotes_orders_aggregates__running": "Cumul des devis et commandes",
    "tool__get_quotes_orders_aggregates__done": "Devis et commandes cumulés",
    "tool__get_team_members__running": "Chargement de la liste de l'équipe",
    "tool__get_team_members__done": "Liste de l'équipe chargée",
    "tool__get_team_overview__running": "Compilation de l'aperçu des activités de l'équipe",
    "tool__get_team_overview__done": "Aperçu des activités de l'équipe compilé",
    "tool__get_team_overview__done_search": "Aperçu des activités de l'équipe compilé pour « {{search}} »",
    "tool__get_team_stats__running": "Calcul des totaux de l'équipe",
    "tool__get_team_stats__done": "Totaux de l'équipe calculés",
    "tool__get_team_stats__done_search": "Totaux de l'équipe calculés pour « {{search}} »"
}
